import { authedGet, authedPut } from "./api";
import {
  api_v3_get_match_by_id,
  api_v3_update_match_by_players,
  api_v3_update_match_by_admin,
} from "../utils/constants";

export const getMatch = async (matchId, token) => {
  const url = api_v3_get_match_by_id(matchId);
  return authedGet(url, token);
};

export const updateMatchByPlayer = async (matchId, data, token) => {
  const url = api_v3_update_match_by_players(matchId);
  return authedPut(url, data, token);
};

export const updateMatchByAdmin = async (matchId, data, token) => {
  const url = api_v3_update_match_by_admin(matchId);
  return authedPut(url, data, token);
};
